import React, { memo, useCallback, useRef, useState } from 'react';
import classNames from 'classnames';

import { unwrap } from '../../../utils/ChangeSpy';

import style from './style.module.css';

export default function DismissAlertDecorator(Component, Alert) {
  const DismissAlert = memo(props => {
    const { value, onBlur, onFocus, onChange } = props;
    const [showReminder, setShowReminder] = useState(false);
    const changed = useRef(false);

    const show = useCallback(
      state => {
        if (state) {
          if (changed.current) {
            setShowReminder(true);
          }
        } else {
          setShowReminder(false);
          changed.current = false;
        }
      },
      [setShowReminder],
    );

    const check = useCallback(() => {
      const text = unwrap(value) || '';

      if (
        /\w+\./gi.test(text) ||
        /(\s+N\s+|\s+B\s+|\s+E\s+|\s+W\s+|\s+NbE\s+|\s+NNE\s+|\s+NEbN\s+|\s+NE\s+)/g.test(text) ||
        /\b\w{1,4}(,|\s+)/gi.test(text)
      ) {
        show(true);
      }
    }, [value, show]);

    const handleBlur = useCallback(
      event => {
        check();
        if (onBlur) {
          onBlur(event);
        }
      },
      [check, onBlur],
    );

    const handleFocus = useCallback(
      event => {
        show(false);
        if (onFocus) {
          onFocus(event);
        }
      },
      [show, onFocus],
    );

    const handleChange = useCallback(
      event => {
        changed.current = true;
        if (onChange) {
          onChange(event);
        }
      },
      [onChange],
    );

    const handleClick = useCallback(() => {
      show(false);
    }, [show]);

    const dismisClass = classNames('alert alert-warning alert-dismissible', {
      hide: !showReminder,
    });

    return (
      <div className={style.host}>
        <Component {...props} onBlur={handleBlur} onChange={handleChange} onFocus={handleFocus} />
        <div className={dismisClass}>
          <button aria-label="Close" className="close" onClick={handleClick} type="button">
            <span aria-hidden="true">&times;</span>
          </button>
          <Alert />
        </div>
      </div>
    );
  });

  DismissAlert.displayName = `DismissAlert(${Component.displayName || Component.name})`;

  return DismissAlert;
}
